module.exports = __webpack_public_path__ + "static/media/restartBtn.7941471d.svg";